/** @jsxImportSource @emotion/react */
import React, { useCallback } from 'react';
import { jsx, css } from '@emotion/react';
import Drawer from '@atlaskit/drawer';
import PageHeader from '@atlaskit/page-header';
import { FormattedMessage } from 'components/i18n';
import Textfield from 'components/textfield';
import Textarea from '@atlaskit/textarea';
import { Field, Form, validate } from 'components/form';
import Button, { ButtonGroup } from '@atlaskit/button';
import { SaleEmail, SaleItem } from '../types';
import { Checkbox } from '@atlaskit/checkbox';
import * as yup from 'yup';
import { DrawerBody, DrawerContainer, DrawerFooter, DrawerHeader } from '../../../components/drawer';
import { useNavigate } from 'react-router';

type Props = {
  onSubmit: (values: any) => void;
  initialValues: SaleEmail;
  isSending?: boolean;
  onCancel: () => void;
}

const schema = yup.object({
  to: yup.array()
    .transform(function(value, originalValue) {
      if (this.isType(value) && value !== null) {
        return value;
      }
      return originalValue ? originalValue.split(/[\s,;]+/) : [];
    })
    .of(yup.string().email(({ value }) => `${value} is not a valid email`)),
});
const EmailComposer: React.FC<Props> = ({initialValues, onSubmit,  onCancel, isSending}) => {

  const navigate = useNavigate();
  const handleSend = useCallback(() => {
    // document.getElementById('emailComposerForm')?.dispatchEvent(new Event('submit', { cancelable: true }))
    document.getElementById('emailComposerForm')?.click();

  },[]);
  return (
    <Drawer
    onClose={onCancel}
    isOpen
    width="wide"
    overrides={{
      Content: {
        cssFn: (defaultStyles) => ({
          ...defaultStyles,
        })
      },
    }}>
      <DrawerContainer>
        <DrawerHeader>
          <PageHeader>
            <FormattedMessage
              id='sale.EmailComposer.title'
              defaultMessage='Send email'
            /></PageHeader>
        </DrawerHeader>
        <DrawerBody>
          <Form<SaleEmail>
            onSubmit={(values) => onSubmit(values)}
            initialValues={initialValues}
            validate={validate(schema)}
          >
            {({ handleSubmit, values, form }) => {
              return (
                <form onSubmit={handleSubmit}>
                  <button id={"emailComposerForm"} type={"submit"} style={{display: 'none'}}>Submit</button>
                  <Field name="to" label={<FormattedMessage
                    id='sale.EmailComposer.to'
                    defaultMessage='To'
                  />} component={Textfield}/>
                  <Field name="bcc" label={<FormattedMessage
                    id='sale.EmailComposer.bcc'
                    defaultMessage='Bcc'
                  />} component={Textfield}/>
                  <Field name="subject" label={<FormattedMessage
                    id='sale.EmailComposer.subjct'
                    defaultMessage='Subject'
                  />}component={Textfield}/>
                  <Field name="body" label={<FormattedMessage
                    id='sale.EmailComposer.message'
                    defaultMessage='Message'
                  />} component={Textarea} minimumRows={8}/>
                  {/*<Field name="bccMyself" label="Options">*/}
                  {/*  {(...input) => <Checkbox {...input} label="BCC myself"/>}*/}
                  {/*</Field>*/}
                </form>)
            }}
          </Form>
        </DrawerBody>
        <DrawerFooter>
          <div
            css={css`
              display: flex;
              justify-content: flex-end;
            `}
          >
            <ButtonGroup>
              <Button appearance="primary"
                      isLoading={isSending}
                      onClick={handleSend}
              ><FormattedMessage
                id='sale.EmailComposer.sendEmail'
                defaultMessage='Send email'
              /></Button>
              <Button appearance="subtle"
                      onClick={onCancel}
              ><FormattedMessage
                id='common.cancel'
                defaultMessage='Cancel'
              /></Button>
            </ButtonGroup>
          </div>
        </DrawerFooter>
      </DrawerContainer>
  </Drawer>);
};

export default EmailComposer;
